module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-fraternity-path-3e15e8ac9d8fa8c9fb98c46dcf4e9992.svg";